import { query } from "@solidjs/router";
import { apiClient } from "../lib/api-client";
import type { SceneElements } from "./SceneElementsTypes";
import type { ServerInfo } from "./RoomConnectionTypes";

export const fetchServerConfig = query(async (): Promise<ServerInfo> => {
  const res = await fetch("/serverConfig.json");
  return res.json();
}, "serverConfig");

export interface RoomDataFromFetchRoom {
  userId: string;
  organizationId: string;
  organizationSlug: string;
  sceneName: string | null;
  title: string | null;
  data: SceneElements;
  variables?: Record<string, any> | null;
  updatedAt: string | null;
}

export const fetchRoom = async (roomId: string): Promise<RoomDataFromFetchRoom | null> => {
  try {
    const response = await apiClient.rooms[":id"].$get({
      param: { id: roomId },
    });

    if (!response.ok) {
      if (response.status !== 404) {
        console.error("Error fetching room:", response.status);
      }
      return null;
    }

    return (await response.json()) as RoomDataFromFetchRoom;
  } catch (error) {
    console.error("Error fetching room:", error);
    return null;
  }
};
